import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const schedulingTerminalsAdapter = getAdapter();

const schedulingTerminalsSlice = createSlice({
  name: 'schedulingTerminals',
  initialState: schedulingTerminalsAdapter.getInitialState(),
  reducers: {
    setSchedulingTerminals: (state, { payload: { schedulingTerminals } }) => {
      schedulingTerminalsAdapter.setAll(state, schedulingTerminals);
    },
  },
});

const selectors = schedulingTerminalsAdapter.getSelectors(({ schedulingTerminals }) => schedulingTerminals);

export const getSchedulingTerminalsIncludingDeleted = (state) => selectors.selectAll(state);

export const getSchedulingTerminals = (state) => getSchedulingTerminalsIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setSchedulingTerminals,
} = schedulingTerminalsSlice.actions;

export default schedulingTerminalsSlice.reducer;
